// MOSTRAR TOAST
interface IToast {
	text: string
	actionText?: string
	onHide?: () => any
	action?: (e: MouseEvent) => void
	fixed?: boolean
	className?: string
}

export const showToast = (data: IToast) => {
	const allToast: NodeListOf<HTMLDivElement> = document.querySelectorAll('.toast') as NodeListOf<
		HTMLDivElement
	>
	const div: HTMLDivElement = document.createElement('div') as HTMLDivElement
	const span: HTMLDivElement = document.createElement('span') as HTMLDivElement
	const btn: HTMLButtonElement = document.createElement('button') as HTMLButtonElement

	// LIMPIAR TODOS LOS TOAST ANTERIORES
	allToast.forEach((el: HTMLDivElement) => document.body.removeChild(el))

	// AGREGAR CLASE
	div.classList.add('toast', data.className || 'normalToast')
	if (data.actionText) div.classList.add('actionToast')

	// AGREGAR TEXTOS Y ACCIONES
	span.textContent = data.text
	btn.textContent = data.actionText || ''

	// EVENTO DE CLICK EN EL BOTÓN ACCIÓN
	btn.addEventListener('click', (e: MouseEvent) => {
		if (data.action) data.action(e)
		div.style.transform = 'translateX(100%)'
		setTimeout(() => {
			try {
				document.body.removeChild(div)
			} catch (err) {
				console.log(err)
			}
			if (data.onHide) data.onHide()
		}, 5300)
	})

	// AGREGAR DIV AL BODY
	div.appendChild(span)
	if (data.actionText) div.appendChild(btn)
	document.body.appendChild(div)

	// ANIMAR HACIA ARRIBA
	setTimeout(() => {
		div.style.transform = 'translateX(0)'
	}, 10)

	// NO ELIMINAR SI ES UN MENSAJE FIJO
	if (!data.fixed) {
		setTimeout(() => {
			div.style.transform = 'translateX(100%)'
		}, 5000)

		setTimeout(() => {
			try {
				document.body.removeChild(div)
			} catch (err) {
				console.log(err)
			}
			if (data.onHide) data.onHide()
		}, 5300)
	}
}
